module.exports = __webpack_public_path__ + "img/ryzs2.9bf6b752.png";